import { Enum } from "../commons/common";

export interface Order {
    id: string;
    trackingCode: string;
    hasApprovedSelfie?: boolean;
    pair: {
        base: string;
        quote: string;
    };
    sourceQuantity: number;
    destinationQuantity: number;
    type: Enum;
    createdBy: string;
    userId?: string;
    side: Enum;
    state: Enum;
    // لیست سفارشات createdAt برمی‌گرداند و جزئیات سفارش createdOn
    createdAt: string;
    createdOn: string;
    commission: number;
    marketType: number;
    source: Enum;
    platform: Enum;
    user: {
        id?: string;
        firstName: string;
        lastName: string;
        userName: string;
    };
    phoneNumber: string;
    baseBalanceAfterOrder: number;
    quoteBalanceAfterOrder: number;
    onPrice: number;
    inDollarPrice: number;
    inDollarAmount: number;
}

export interface OrderCount {
    pageSize: number;
    pageIndex: number;
    totalPages: number;
    totalCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

// مقادیر باید دقیقاً با enum بک‌اند یکی باشند:
// Data/QueryTools/Pagaination/PaginatedList.cs → Asc = 1, Desc = 2
// قبلاً 0/1 بود و باعث می‌شد «نزولی» (۱) در بک‌اند به‌عنوان Asc خوانده شود.
export enum SortDirection {
    ASC = 1,
    DESC = 2,
}

export interface OrderFilterValues {
    startDate?: string;
    endDate?: string;
    sort?: SortDirection;
    market?: string;
    sourceCampaign?: string;
    platformType?: Enum;
    trackingCode?: string;
    fullName?: string;
    phoneNumber?: string;
    minAmount?: string;
    maxAmount?: string;
    source?: Enum;
    side: Enum;
    marketType?: Enum;
    type?: Enum;
    state?: Enum;
}

export enum OrderAction {
    ConfirmAndPayout = 100,
    Succeed = 7,
    Cancel = 1,
}

export const OrderActionLabel = new Map<number, string>([
    [OrderAction.ConfirmAndPayout, "تایید و تسویه"],
]);
